import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
  standalone: true
})
export class NumberFormatPipe implements PipeTransform {


  transform(value: any, type: string, dp: number = 1): string {
    if (isNaN(value)) { return ''; }
    if (value == null || value == undefined) { return ''; }
    if (value == 0) { return '0'; }

    if (type == "ms2s") {
      return (value / 1000).toFixed(dp);
    }
    else if (type == "kmb") {
      var exp, rounded,
        suffixes = ['k', 'M', 'B', 'T'];

      if (value < 1000) {
        return value.toFixed(dp);
      }

      exp = Math.floor(Math.log(value) / Math.log(1000));

      return (value / Math.pow(1000, exp)).toFixed(dp) + suffixes[exp - 1];

    }
    else {
      throw new Error(`Invalid format type specified: ${type}`);
    }
  }

}
